import './profile_main_view.js.coffee';# Added by Script 
import './user_profile_view.js.coffee'
Customer.Users ||= {}

class Customer.Users.ProfilePreviewMainView extends Customer.Users.ProfileMainView
  template: JST["backbone/templates/customer/users/user_profile_main_preview"]

  id: 'main-profile-preview'
  className : ''

  render: ->
    @_checkInstagramSource()
    @_renderProfile()
    @_renderProfileAttributes()
    @_renderProfileTags()
    @

  _checkInstagramSource: ->
    @source = 'instagram' if /instagram/.test(@source)

  _renderProfile: ->
    @$el.html @template(
      source: @source
      profile: @profile
      socialUsers: @socialUsers
      getSocialUserType: @getSocialUserType
      name: @_getName()
    )

  _renderProfileAttributes: ->
    @profileAttributesView = new Customer.Users.ProfilePreviewAttributesView(
      profile: @profile,
      social_users: _.sortBy(@socialUsers, (user) => if @getSocialUserType(user) == @source then 0 else 1),
      attribute_definitions: @editableAttributes,
      get_social_user_type: @getSocialUserType,
      ticket_social_user_id: @socialId
    )
    @listenTo @profileAttributesView, 'profile:social-user-removed', (response) =>
      @trigger 'profile:social-user-removed', response
    @listenTo @profileAttributesView, 'profile_custom_attributes:change', (response) =>
      @trigger 'profile_custom_attributes:change', response
    @listenTo @profileAttributesView, 'profile_custom_attributes:restore', =>
      @trigger 'profile_custom_attributes:restore'
    @$el.find('#profile-body').append(@profileAttributesView.render().el)

  _renderProfileTags: ->
    @profileTagsView = new Customer.Users.ProfileTagsView(profile: @profile)
    @$el.find('#profile-body').append(@profileTagsView.render().el)

  update: ({profile}) =>
    @profile = profile
    @render()

  onAttributesValidationError: (userProfileAttributeErrors) =>
    @profileAttributesView.onAttributesValidationError(userProfileAttributeErrors)

  onTicketClose: =>
    @profileAttributesView.onTicketClose()
